<avd-styling-card-shell [label]="label">
    <div token-card-preview class="typography-preview">
        <p
            class="typography-preview__text"
            [style.font]="
                typographyStyle ? 'var(' + typographyStyle + ')' : 'inherit'
            "
        >
            "The quick brown fox jumps over the lazy dog. J. Fox made five quick
            plays to win the big prize! The quick onyx goblin jumps over the
            lazy dwarf. A wizard’s job is to vex chumps quickly in fog."
        </p>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="longhandSnippet"
        language="css"
    ></avd-css-variable-snippet>

    <avd-css-variable-snippet
        token-card-snippets
        title="shorthand"
        [snippet]="shorthandSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
